/**
 * product
 */

import Vue from 'vue/dist/vue.common';
import Component from '../../js/lib/component';

import store, { eventBus } from '../../js/Store';
import counter from '../counter/counter.vue';

const classList = {
    root: '.js-product-order'
};

export default class ProductOrder extends Component {
    init() {
        const id = Number(this.$.root.data('id'));
        const amount = Number(this.$.root.data('amount')) || 1;
        const max = Number(this.$.root.data('max')) || Infinity;

        new Vue({
            name: 'Product',
            el: this.$.root.get(0),
            data: {
                id,
                amount,
                max,
                inCart: false,
                isReady: false,
                isLoading: false
            },
            store,
            components: {
                counter
            },
            methods: {
                init() {
                    store.dispatch('getProduct', this.id).then(([product]) => {
                        this.isReady = true;

                        if (product) {
                            this.inCart = true;
                        }
                    });
                },
                addToCart() {
                    this.isLoading = true;

                    if (id) {
                        store
                            .dispatch('addProduct', {
                                id: this.id,
                                amount: this.amount
                            })
                            .done(() => {
                                this.inCart = true;
                            })
                            .fail((err) => {
                                console.error(err);
                            })
                            .always(() => {
                                this.isLoading = false;
                            });
                    }
                },
                updateAmount({ amount }) {
                    this.amount = amount;
                    store.dispatch('updateProductAmount', {
                        id: this.id,
                        amount
                    });
                }
            },
            mounted() {
                setTimeout(() => this.init(), 0);

                eventBus.$on('product.remove', ({ id }) => {
                    if (id === this.id) {
                        this.inCart = false;
                    }
                });

                eventBus.$on('product.add', ({ id }) => {
                    if (id === this.id) {
                        this.inCart = true;
                    }
                });
            }
        });
    }
}

Component.mount(ProductOrder, {
    name: 'ProductOrder',
    classList,
    state: {}
});
